// extracted by mini-css-extract-plugin
export default {"Subheading":"webpack-concepts-Extraction-Blocks-Subheading-control-Subheading-module__Subheading"};